import { Component } from '@verndale/core';
import Swiper, { Navigation, Scrollbar } from 'swiper';

import { breakpoints } from '../../helpers/constants';

Swiper.use([Navigation, Scrollbar]);

class LogoRow extends Component {
  setupDefaults() {
    this.dom = {
      inner: this.el.querySelector('.image-carousel__container'),
      slides: this.el.querySelectorAll('.swiper-slide'),
      scrollbar: this.el.querySelector('.image-carousel__scrollbar'),
      navigation: this.el.querySelector('.image-carousel__buttons'),
      prevButton: this.el.querySelector('.image-carousel__button--prev'),
      nextButton: this.el.querySelector('.image-carousel__button--next')
    };

    if (this.dom.slides.length > 1) {
      this.initCarousel();
    } else {
      this.dom.scrollbar.remove();
      this.dom.navigation.remove();
    }
  }

  initCarousel() {
    new Swiper(this.dom.inner, {
      slidesPerView: 1.25,
      spaceBetween: 22,
      breakpoints: {
        [breakpoints.tabletLandscape]: {
          spaceBetween: 68
        }
      },
      navigation: {
        nextEl: this.dom.nextButton,
        prevEl: this.dom.prevButton
      },
      scrollbar: {
        el: this.dom.scrollbar,
        draggable: true,
        dragClass: 'image-carousel__scrollbar-drag'
      }
    });
  }
}

export default LogoRow;
